import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, signInWithEmailAndPassword } from 'firebase/auth';
import { env } from './env';

// Firebase Web App "MedicLynk Admin Portal" (appId ends 6969f), registered as its own app
// distinct from the mobile app's Firebase registration — required so App Check (ADM-14) and
// Firebase console usage metrics can be scoped to the portal specifically.
//
// When talking to the local Auth emulator, the SDK routes requests by `projectId` — it must
// match the "demo-mediclynk" namespace the backend's Firebase Admin SDK is initialized against
// (see backend/.env), not the real Firebase project, otherwise the backend's verifyIdToken()
// rejects on audience mismatch. Mirrors app/services/firebaseAuth.ts's emulator handling.
const firebaseConfig = {
  apiKey: env.useFirebaseAuthEmulator ? 'demo-api-key' : env.firebaseApiKey,
  authDomain: env.firebaseAuthDomain,
  projectId: env.useFirebaseAuthEmulator ? 'demo-mediclynk' : env.firebaseProjectId,
  storageBucket: env.firebaseStorageBucket,
  messagingSenderId: env.firebaseMessagingSenderId,
  appId: env.firebaseAppId,
  measurementId: env.firebaseMeasurementId,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

if (env.useFirebaseAuthEmulator) {
  connectAuthEmulator(auth, `http://${env.firebaseAuthEmulatorHost}:9099`, {
    disableWarnings: true,
  });
  console.log(`🔥 [firebase] Connected to local Auth emulator at ${env.firebaseAuthEmulatorHost}:9099`);

  // e2e-only hook (see tests/e2e/helpers/auth.ts). The portal dropped its email/password UI
  // (SSO-only login now) but Playwright can't drive a real Google/Microsoft OAuth consent
  // screen, so e2e signs in directly against the Auth emulator's seeded demo accounts through
  // this hook instead of the UI. Only ever attached when talking to the local emulator —
  // `useFirebaseAuthEmulator` is never true against a real Firebase project/deployment.
  (window as unknown as { __mediclynkTestSignIn?: (email: string, password: string) => Promise<unknown> }).__mediclynkTestSignIn =
    (email: string, password: string) => signInWithEmailAndPassword(auth, email, password);
}
